import React from "react";
import { useNavigate } from "react-router-dom";
import "./Banner.css";

const Banner = () => {
  const navigate = useNavigate();

  return (
    <section className="cta5" aria-labelledby="cta5-heading">
      <div className="cta5-wrap">
        <div className="cta5-main">
          <div className="cta5-copy">
            <p className="cta5-kicker">Moving from another host?</p>

            <h2 id="cta5-heading" className="cta5-title">
              Migration checklist + <span>hands-on help</span>
            </h2>

            <p className="cta5-sub">
              Virtue Digi coordinates files, databases, DNS, and SSL so your cutover
              is planned—not guessed. Share your stack and we’ll outline effort and
              timing before you commit.
            </p>

            <div className="cta5-actions">
              <button
                className="cta5-btn cta5-btnPrimary"
                type="button"
                onClick={() => navigate("/contact")}
              >
                Start migration chat
              </button>

              <button
                className="cta5-btn cta5-btnOutline"
                type="button"
                onClick={() => navigate("/services")}
              >
                Compare hosting
              </button>
            </div>
          </div>

          <aside className="cta5-side" aria-label="What we handle">
            <p className="cta5-sideLabel">Migration support</p>
            <p className="cta5-sideSub">
              Practical steps so email keeps flowing and HTTPS stays valid during
              the switch.
            </p>

            <div className="cta5-list">
              <div className="cta5-li">
                <span className="cta5-bullet" />
                <div>
                  <div className="cta5-liTitle">Files & database</div>
                  <div className="cta5-liText">WordPress, static sites, custom PHP</div>
                </div>
              </div>

              <div className="cta5-li">
                <span className="cta5-bullet" />
                <div>
                  <div className="cta5-liTitle">DNS & propagation</div>
                  <div className="cta5-liText">Lower TTL before go-live when needed</div>
                </div>
              </div>

              <div className="cta5-li">
                <span className="cta5-bullet" />
                <div>
                  <div className="cta5-liTitle">SSL & redirects</div>
                  <div className="cta5-liText">HTTPS, mixed content, forced SSL</div>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
};

export default Banner;
